import React from 'react';
import {ShowIf} from 'components/utils';
import { Button } from '@blueprintjs/core';
import { Input } from 'components/tt-forms/common';

class TableKetQuaPhongChongThamNhung extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      dataList: this.props.dataList || [],
      dataSum: this.props.dataSum || {},
      header: [
        {ms: null, content: 'CHÍNH SÁCH, PHÁP LUẬT', className: 'txt-bold', unit: null},
        {ms: 1, content: 'Số văn bản ban hành mới để thực hiện Luật PCTN và các văn bản hướng dẫn thi hành Luật PCTN', className: '', unit: 'Văn bản', field: 'chinhSachPhapLuatSoVanBanBanHanh'},
        {ms: 2, content: 'Số văn bản được sửa đổi, bổ sung để thực hiện Luật PCTN và các văn bản hướng dẫn thi hành', className: '', unit: 'Văn bản', field: 'chinhSachPhapLuatSoVanBanDuocSuaDoi'},

        {ms: null, content: 'TUYÊN TRUYỀN, PHỔ BIẾN, GIÁO DỤC PHÁP LUẬT VỀ PCTN', className: 'txt-bold', unit: null},
        {ms: 3, content: 'Số lượt cán bộ, công chức, viên chức, nhân dân tham gia các lớp tập huấn, quán triệt pháp luật về PCTN', className: '', unit: 'Lượt người', field: 'tuyenTruyenPBGDPLVePCTNSoLuotCanBo'},
        {ms: 4, content: 'Số lớp tuyên truyền, quán triệt pháp luật về phòng, chống tham nhũng được tổ chức', className: '', unit: 'Lớp', field: 'tuyenTruyenPBGDPLVePCTNSoLop'},
        {ms: 5, content: 'Số lượng đầu sách, tài liệu về pháp luật phòng, chống tham nhũng được xuất bản', className: '', unit: 'Tài liệu', field: 'tuyenTruyenPBGDPLVePCTNSoLuongDauSach'},

        {ms: null, content: 'THỰC HIỆN CÁC BIỆN PHÁP PHÒNG NGỪA THAM NHŨNG', className: 'txt-bold', unit: null},
        {ms: null, content: 'Công khai, minh bạch trong hoạt động của cơ quan, tổ chức, đơn vị (gọi chung là đơn vị)', className: 'txt-bold', unit: null},
        {ms: 6, content: 'Số cơ quan, tổ chức, đơn vị được kiểm tra việc thực hiện các quy định về công khai, minh bạch', className: '', unit: 'CQ, TC, ĐV', field: 'thucHienCacBPPNTNSoCoQuanTCDVDuocKiemTra'},
        {ms: 7, content: 'Số cơ quan, tổ chức, đơn vị bị phát hiện có vi phạm quy định về công khai, minh bạch hoạt động', className: '', unit: 'CQ, TC, ĐV', field: 'thucHienCacBPPNTNSoCoQuanTCDVBiPhatHien'},

        {ms: null, content: 'Xây dựng và thực hiện các chế độ, định mức, tiêu chuẩn', className: 'txt-bold', unit: null},
        {ms: 8, content: 'Số văn bản về chế độ, định mức, tiêu chuẩn đã được ban hành mới', className: '', unit: 'Văn bản', field: 'thucHienCacBPPNTNSoVanBanDuocBanHanhMoi'},
        {ms: 9, content: 'Số văn bản về chế độ, định mức, tiêu chuẩn đã được sửa đổi, bổ sung cho phù hợp', className: '', unit: 'Văn bản', field: 'thucHienCacBPPNTNSoVanBanDuocSuaDoiBoSungChoPhuHop'},
        {ms: 10, content: 'Số cuộc kiểm tra việc thực hiện các quy định về chế độ, định mức, tiêu chuẩn', className: '', unit: 'Cuộc', field: 'thucHienCacBPPNTNSoCuocKiemTra'},
        {ms: 11, content: 'Số vụ vi phạm các quy định về chế độ, định mức, tiêu chuẩn đã được phát hiện và xử lý', className: '', unit: 'Vụ', field: 'thucHienCacBPPNTNSoVuViPham'},
        {ms: 12, content: 'Số người bị phát hiện đã vi phạm các quy định về chế độ, định mức, tiêu chuẩn', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiBiPhatHienDaViPham'},
        {ms: 13, content: 'Số người vi phạm các quy định về chế độ, định mức, tiêu chuẩn đã bị xử lý kỷ luật', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiViPhamDaBiXuLyKyLuat'},
        {ms: 14, content: 'Số người vi phạm các quy định về chế độ, định mức, tiêu chuẩn đã bị xử lý hình sự', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiViPhamDaBiXuLyHinhSu'},
        {ms: 15, content: 'Tổng giá trị các vi phạm về chế độ, định mức, tiêu chuẩn được kiến nghị thu hồi và bồi thường (nếu là ngoại tệ, tài sản thì quy đổi thành tiền).', className: '', unit: 'Triệu đồng', field: 'thucHienCacBPPNTNTongGiaTriDuocKienNghi'},
        {ms: 16, content: 'Tổng giá trị vi phạm chế độ, định mức, tiêu chuẩn đã được thu hồi và bồi thường', className: '', unit: 'Triệu đồng', field: 'thucHienCacBPPNTNTongGiaTriDuocThuHoiVaBoiThuong'},
        {ms: 17, content: 'Số người đã nộp lại quà tặng cho đơn vị', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiDaNopLaiQuaTang'},
        {ms: 18, content: 'Giá trị quà tặng đã được nộp lại (Nếu là ngoại tệ, tài sản thì quy đổi thành tiền)', className: '', unit: 'Triệu đồng', field: 'thucHienCacBPPNTNGiaTriQuaTang'},

        {ms: null, content: 'Thực hiện quy tắc ứng xử, chuyển đổi vị trí công tác của cán bộ, công chức, viên chức', className: 'txt-bold', unit: null},
        {ms: 19, content: 'Số cơ quan, tổ chức, đơn vị đã được kiểm tra việc thực hiện quy tắc ứng xử của cán bộ, công chức', className: '', unit: 'CQ, TC, ĐV', field: 'thucHienCacBPPNTNSoCoQuanTCDVThucHienQuyTacUngXu'},
        {ms: 20, content: 'Số cán bộ, công chức, viên chức vi phạm quy tắc ứng xử, quy tắc đạo đức nghề nghiệp đã bị xử lý', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoCanBoViPhamQuyTacUngXu'},
        {ms: 21, content: 'Số cán bộ, công chức, viên chức được chuyển đổi vị trí công tác nhằm phòng ngừa tham nhũng', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoCanBoDuocChuyenDoiVTCTPNTN'},

        {ms: null, content: 'Thực hiện các quy định về minh bạch tài sản, thu nhập', className: 'txt-bold', unit: null},
        {ms: 22, content: 'Số người được xác minh việc kê khai tài sản, thu nhập', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiDuocXMViecKeKhaiTSThuNhap'},
        {ms: 23, content: 'Số người bị kết luận kê khai không trung thực', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiBiKetLuanKKHKhongTrungThuc'},

        {ms: null, content: 'Trách nhiệm của người đứng đầu các cơ quan, tổ chức, đơn vị khi để xẩy ra tham nhũng', className: 'txt-bold', unit: null},
        {ms: 24, content: 'Số người đứng đầu bị kết luận là thiếu trách nhiệm để xẩy ra hành vi tham nhũng', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiDDBiKLThieuTrachNhiem'},
        {ms: 25, content: 'Số người đứng đầu đã bị xử lý hình sự do thiếu trách nhiệm để xẩy ra hành vi tham nhũng', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiDDDaBiXLHSThieuTrachNhiem'},
        {ms: 26, content: 'Số người đứng đầu bị xử lý kỷ luật do thiếu trách nhiệm để xảy ra tham nhũng', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiDDBiKLKyLuat'},

        {ms: null, content: 'Cải cách hành chính, đổi mới công nghệ quản lý và phương thức thanh toán', className: 'txt-bold', unit: null},
        {ms: 27, content: 'Số cơ quan, tổ chức đã áp dụng ISO trong quản lý hành chính', className: '', unit: 'CQ, TC, ĐV', field: 'thucHienCacBPPNTNSoCoQuanTCDaApDungISO'},
        {ms: 28, content: 'Tỷ lệ cơ quan, tổ chức đã chi trả lương qua tài khoản trên tổng số cơ quan, đơn vị trực thuộc', className: '', unit: '%', field: 'thucHienCacBPPNTNTyLeCoQuanTCDaChiTraLuong'},

        {ms: null, content: 'PHÁT HIỆN CÁC VỤ VIỆC THAM NHŨNG', className: 'txt-bold', unit: null},
        {ms: null, content: 'Qua việc tự kiểm tra nội bộ', className: 'txt-bold', unit: null},
        {ms: 29, content: 'Số vụ tham nhũng đã được phát hiện qua việc tự kiểm tra nội bộ', className: '', unit: 'Vụ', field: 'thucHienCacBPPNTNSoVuThamNhungDaDuocPhatHienQuaKTNoiBo'},
        {ms: 30, content: 'Số đối tượng có hành vi tham nhũng được phát hiện qua việc tự kiểm tra nội bộ', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoDoiTuongThamNhungDuocPhatHienQuaKTNoiBo'},

        {ms: null, content: 'Qua hoạt động thanh tra ', className: 'txt-bold', unit: null},
        {ms: 31, content: 'Số vụ tham nhũng được phát hiện qua công tác thanh tra', className: '', unit: 'Vụ', field: 'thucHienCacBPPNTNSoVuThamNhungDuocPhatHienQuaCTThanhTra'},
        {ms: 32, content: 'Số đối tượng có hành vi tham nhũng bị phát hiện qua công tác thanh tra', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoDoiTuongThamNhungBiPhatHienQuaCTThanhTra'},

        {ms: null, content: 'Qua công tác giải quyết khiếu nại, tố cáo', className: 'txt-bold', unit: null},
        {ms: 33, content: 'Số đơn tố cáo về tham nhũng thuộc thẩm quyền giải quyết của các cơ quan, tổ chức', className: '', unit: 'Đơn', field: 'thucHienCacBPPNTNSoDonToCaoThamNhungThuocTQGQCuaCacCQTC'},
        {ms: 34, content: 'Số đơn tố cáo về tham nhũng đã được giải quyết', className: '', unit: 'Đơn', field: 'thucHienCacBPPNTNSoDonToCaoThamNhungDaDuocGiaiQuyet'},
        {ms: 35, content: 'Số vụ tham nhũng được phát hiện thông qua giải quyết khiếu nại, tố cáo', className: '', unit: 'Vụ', field: 'thucHienCacBPPNTNSoVuThamNhungDuocPhatHienQuaGQKNTC'},
        {ms: 36, content: 'Số đối tượng có hành vi tham nhũng bị phát hiện qua giải quyết khiếu nại, tố cáo', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoDoiTuongThamNhungBiPhatHienQuaGQKNTC'},

        {ms: null, content: 'Qua điều tra tội phạm ', className: 'txt-bold', unit: null},
        {ms: 37, content: 'Số vụ án tham nhũng (thuộc phạm vi quản lý) đã được cơ quan chức năng khởi tố', className: '', unit: 'Vụ', field: 'thucHienCacBPPNTNSoVuAnThamNhungDuocCoQuanCNKhoiTo'},
        {ms: 38, content: 'Số đối tượng tham nhũng (thuộc phạm vi quản lý) đã bị cơ quan chức năng khởi tố', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoDoiTuongThamNhungBiCoQuanCNKhoiTo'},

        {ms: null, content: 'XỬ LÝ CÁC HÀNH VI THAM NHŨNG ', className: 'txt-bold', unit: null},
        {ms: 39, content: 'Số vụ án tham nhũng đã đưa ra xét xử (địa phương thống kê kết quả xét xử sơ thẩm của toà án; bộ, ngành thống kê theo kết quả xét xử sơ thẩm đối với các vụ án xảy ra trong phạm vi quản lý trực tiếp)', className: '', unit: 'Vụ', field: 'thucHienCacBPPNTNSoVuAnThamNhungDaDuaRaXetXu'},
        {ms: 40, content: 'Số đối tượng bị kết án tham nhũng (địa phương thống kê kết quả xét xử sơ thẩm của toà án; bộ, ngành thống kê theo kết quả xét xử sơ thẩm đối với các vụ án xảy ra trong phạm vi quản lý trực tiếp)', className: '', unit: 'Người', field: 'soDoiTuongBiKetAnThamNhung'},

        {ms: null, content: 'Trong đó:', className: '', unit: null},
        {ms: 41, content: '+ Số đối tượng phạm tội tham nhũng ít nghiêm trọng', className: 'pl30', unit: 'Người', field: 'thucHienCacBPPNTNSoDoiTuongBiKetAnThamNhungItNghiemTrong'},
        {ms: 42, content: '+ Số đối tượng phạm tội tham nhũng nghiêm trọng', className: 'pl30', unit: 'Người', field: 'thucHienCacBPPNTNSoDoiTuongPhamToiThamNhungNghiemTrong'},
        {ms: 43, content: '+ Số đối tượng phạm tội tham nhũng rất nghiêm trọng', className: 'pl30', unit: 'Người', field: 'thucHienCacBPPNTNSoDoiTuongPhamToiThamNhungRatNghiemTrong'},
        {ms: 44, content: '+ Số đối tượng phạm tội tham nhũng đặc biệt nghiêm trọng', className: 'pl30', unit: 'Người', field: 'thucHienCacBPPNTNSoDoiTuongPhamToiThamNhungDacBietNghiemTrong'},

        {ms: 45, content: 'Số vụ việc tham nhũng đã được xử lý hành chính', className: '', unit: 'Vụ', field: 'thucHienCacBPPNTNSVuViecThamNhungDuocXLHanhChinh'},
        {ms: 46, content: 'Số cán bộ, công chức, viên chức bị xử lý kỷ luật hành chính về hành vi tham nhũng', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoCanBoCCVCBiKyLuatHCHanhViThamNhung'},
        {ms: 47, content: 'Số vụ việc tham nhũng đã được phát hiện, đang được xem xét để xử lý (chưa có kết quả xử lý)', className: '', unit: 'Vụ', field: 'thucHienCacBPPNTNSoVuViecThamNhungDuocPhatHienXemXetXuLy'},
        {ms: 48, content: 'Số đối tượng tham nhũng đã được phát hiện, đang được xem xét để xử lý (chưa có kết quả xử lý)', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoDoiTuongThamNhungDuocPhatHienDangXemXetXuLy'},

        {ms: null, content: 'Tài sản bị tham nhũng, gây thiệt hại do tham nhũng đã phát hiện được', className: 'txt-bold', unit: null},
        {ms: 49, content: '+ Bằng tiền (tiền Việt Nam + ngoại tệ, tài sản khác được quy đổi ra tiền Việt Nam)', className: '', unit: 'Triệu đồng', field: 'thucHienCacBPPNTNTaiSanThamNhungPhatHienDuocBangTien'},
        {ms: 50, content: '+ Đất đai ', className: '', unit: 'm2', field: 'thucHienCacBPPNTNTaiSanThamNhungPhatHienDuocBangDatDai'},

        {ms: null, content: 'Tài sản tham nhũng, gây thiệt hại do tham nhũng đã được thu hồi, bồi thường', className: 'txt-bold', unit: null},
        {ms: 51, content: '+ Bằng tiền (tiền Việt Nam + ngoại tệ, tài sản khác được quy đổi ra tiền Việt Nam)', className: '', unit: 'Triệu đồng', field: 'thucHienCacBPPNTNTaiSanThamNhungDuocThuHoiBangTien'},
        {ms: 52, content: '+ Đất đai ', className: '', unit: 'm2', field: 'thucHienCacBPPNTNTaiSanThamNhungDuocThuHoiBangTien'},

        {ms: null, content: 'Tài sản tham nhũng, gây thiệt hại do tham nhũng không thể thu hồi, khắc phục được', className: 'txt-bold', unit: null},
        {ms: 53, content: '+ Bằng tiền (tiền Việt Nam + ngoại tệ, tài sản khác được quy đổi ra tiền Việt Nam)', className: '', unit: 'Triệu đồng', field: 'thucHienCacBPPNTNTaiSanThamNhungKhongTheThuHoiBangTien'},
        {ms: 54, content: '+ Đất đai ', className: '', unit: 'm2', field: 'thucHienCacBPPNTNTaiSanThamNhungKhongTheThuHoiBangTien'},

        {ms: null, content: 'Bảo vệ người tố cáo, phát hiện tham nhũng', className: 'txt-bold', unit: null},
        {ms: 55, content: 'Số người tố cáo hành vi tham nhũng đã bị trả thù', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiToCaoHanhViThamNhungBiTraThu'},
        {ms: 56, content: 'Số người tố cáo hành vi tham nhũng đã được khen, thưởng, trong đó:', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiToCaoHanhViThamNhungDuocKhenThuong'},
        {ms: 57, content: '+ Tặng Bằng khen của Thủ tướng Chính phủ', className: 'pl30', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiDuocTangBangKhenCuaThuTuongChinhPhu'},
        {ms: 58, content: '+ Tặng Bằng khen của Bộ, ngành, địa phương', className: 'pl30', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiTangBangKhenCuaBoNganhDiaPhuong'},
        {ms: 59, content: '+ Tặng Giấy khen', className: 'pl30', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiTangGiayKhen'}
      ],
      down: false,
      scrollLeft: '',
      scrollTop: '',
      x: '',
      y: ''
    }
  }

  handleDown(e) {
    if (this.props.touchMove) {
      let Item = document.getElementById('scrollItem');
      document.getElementById('scrollItem').classList.add("scrolling");
      this.state.down = true;
      this.state.scrollLeft = Item.scrollLeft;
      this.state.scrollTop = Item.scrollTop;
      this.state.x = e.clientX;
      this.state.y = e.clientY;
    }
  }

  handleUp() {
    if (this.props.touchMove) {
      document.getElementById('scrollItem').classList.remove("scrolling");
      this.state.down = false;
    }
  }

  handleMove(e) {
    if (this.props.touchMove) {
      let Item = document.getElementById('scrollItem');
      if (this.state.down == true) {
        Item.scrollLeft = this.state.scrollLeft + this.state.x - e.clientX;
        Item.scrollTop = this.state.scrollTop + this.state.y - e.clientY;
      }
    }
  }

  handleLeave() {
    if (this.props.touchMove) {
      document.getElementById('scrollItem').classList.remove("scrolling");
      this.state.down = false;
    }
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.dataList != nextProps.dataList) {
      this.setState({
        dataList: nextProps.dataList
      })
    }
    this.setState({
      dataSum: nextProps.dataSum
    })
  }

  componentDidMount() {
  }

  addNewItem() {
    this.props.addNewItem();
  }

  checkScroll() {
    let scrollContainer = document.getElementById('scrollItem');

    document.getElementById("tableFixed").style.cssText = "top: " + (-1 * scrollContainer.scrollTop) + 'px';
    document.getElementById("tableHeaderFixed").style.cssText = "left: " + ((-1 * scrollContainer.scrollLeft) + 1) + 'px';
  }

  onChange(name, index, e) {
    this.state.dataList[index][name] = e.target.value;
    this.setState({
      ...this.state
    },() => {
      this.props.pushData(this.state.dataList)
    })
  }

  onChangeHeader(index, e) {
    this.state.dataList[index].donVi = {
      id: null,
      ten: e.target.value
    }
    this.state.dataList[index].tenDonVi = e.target.value;
    this.setState({
      ...this.state
    },() => {
      this.props.pushData(this.state.dataList)
    })
  }

  handleExport() {
    this.props.handleExport()
  }

  render() {
    return (
      <div className='wrapper-tkbc table-custom'>
        <div
          className={`table-container ${this.props.touchMove == true ? 'touch-move' : ''}`}
          onMouseUp={this.handleUp.bind(this)}
          onMouseDown={this.handleDown.bind(this)}
          onMouseMove={this.handleMove.bind(this)}
          onMouseLeave={this.handleLeave.bind(this)}
          onScroll={this.checkScroll.bind(this)}
          id='scrollItem'>
          <div className='wrap-fixed-table' style={{overflowY: 'scroll'}}>
            <table className='table-header-fixed' id='tableHeaderFixed'>
              <thead className='table-header'>
                <tr>
                  <th style={{width: 40, minWidth: 40, maxWidth: 40, opacity: 0, visibility: 'hidden'}} className='middle-content'>MS</th>
                  <th style={{width: 600, minWidth: 600, maxWidth: 600, opacity: 0, visibility: 'hidden'}} className='middle-content txt-left'>Nội dung</th>
                  <th style={{width: 110, minWidth: 110, maxWidth: 110, opacity: 0, visibility: 'hidden'}} className='middle-content txt-left'>Đơn vị tính</th>
                  {
                    this.state.dataList.map((item, index) => {
                      if(typeof item.donVi != 'undefined' && item.donVi.id) {
                        return(
                          <th style={{minWidth: 150, maxWidth: 150, width: 150}} key={index} className='middle-content txt-left'>{item && item.donVi && item.donVi.ten ? item.donVi.ten : ''}</th>
                        )
                      } else {
                        return(
                          <th style={{minWidth: 150, maxWidth: 150, width: 150}} key={index} className='middle-content txt-left'><Input className='col-100 no-gutter mb0-18' onChange={this.onChangeHeader.bind(this, index)} triggeOnBlur={true} value={item && item.donVi && item.donVi.ten ? item.donVi.ten : ''}/></th>
                        )
                      }
                    })
                  }
                  <ShowIf condition={this.props.addNew == true}>
                    <th style={{minWidth: 150}} className='middle-content txt-left'>
                      <span className='tr-sum-name txt-blue pointer' onClick={this.addNewItem.bind(this)}><i className='tt tt-addfile tt-custom'/>Thêm mới đơn vị</span>
                    </th>
                  </ShowIf>
                  <ShowIf condition={this.state.dataList.length > 1}>
                    <th style={{width: 110, minWidth: 110, maxWidth: 110}} className='middle-content txt-left'>Tổng cộng</th>
                  </ShowIf>
                </tr>
              </thead>
            </table>
          </div>
          <div className='wrap-fixed-table'>
            <table className='table-content-fixed'>
              <thead className='table-header'>
                <tr>
                  <th style={{width: 40, minWidth: 40, maxWidth: 40}} className='middle-content'>MS</th>
                  <th style={{width: 600, minWidth: 600, maxWidth: 600}} className='middle-content txt-left'>Nội dung</th>
                  <th style={{width: 110, minWidth: 110, maxWidth: 110}} className='middle-content txt-left'>Đơn vị tính</th>
                  {
                    this.state.dataList.map((item, index) => {
                      if(typeof item.donVi != 'undefined' && item.donVi.id) {
                        return(
                          <th style={{minWidth: 150, maxWidth: 150, width: 150, opacity: 0, visibility: 'hidden'}} key={index} className='middle-content txt-left'>{item && item.donVi && item.donVi.ten ? item.donVi.ten : ''}</th>
                        )
                      } else {
                        return(
                          <td style={{minWidth: 150, maxWidth: 150, width: 150, opacity: 0, visibility: 'hidden'}} key={index} className='txt-left'><Input className='col-100 no-gutter mb0-18' onChange={this.onChangeHeader.bind(this, index)} triggeOnBlur={true} value={item && item.donVi && item.donVi.ten ? item.donVi.ten : ''}/></td>
                        )
                      }
                    })
                  }
                  <ShowIf condition={this.props.addNew == true}>
                    <th style={{minWidth: 150, opacity: 0, visibility: 'hidden'}} className='middle-content txt-left'>
                      <span className='tr-sum-name txt-blue pointer' onClick={this.addNewItem.bind(this)}><i className='tt tt-addfile tt-custom'/>Thêm mới đơn vị</span>
                    </th>
                  </ShowIf>
                  <ShowIf condition={this.state.dataList.length > 1}>
                    <th style={{width: 110, minWidth: 110, maxWidth: 110, opacity: 0, visibility: 'hidden'}} className='middle-content txt-left'>Tổng cộng</th>
                  </ShowIf>
                </tr>
              </thead>
              <tbody style={{opacity: 0, visibility: 'hidden'}}>
                {
                  this.state.header.map((item, index) => {
                    return(
                      <tr key={index}>
                        <td style={{width: 40, minWidth: 40, maxWidth: 40, opacity: 0, visibility: 'hidden'}}>{item.ms ? item.ms : ''}</td>
                        <td style={{width: 600, minWidth: 600, maxWidth: 600, opacity: 0, visibility: 'hidden'}} className={`txt-left ${item.className ? item.className : ''}`}>{item.content ? item.content : ''}</td>
                        <td style={{width: 110, minWidth: 110, maxWidth: 110, opacity: 0, visibility: 'hidden'}} className='txt-left'>{item.unit ? item.unit : ''}</td>
                        {
                          this.state.dataList.map((data, i) => {
                            if((typeof data.donVi != 'undefined' && data.donVi.id) || item.ms == null) {
                              return(
                                <td style={{minWidth: 150, maxWidth: 150, width: 150}} key={i} className='txt-left'>{data && data[item.field] ? data[item.field] : (item.ms ? 0 : '')}</td>
                              )
                            } else {
                              return(
                                <td style={{minWidth: 150, maxWidth: 150, width: 150}} key={i} className='txt-left'><Input className='col-100 no-gutter mb0-18' onChange={this.onChange.bind(this, item.field, i)} type='sdt' triggeOnBlur={true} value={data && data[item.field] ? data[item.field] : 0}/></td>
                              )
                            }
                          })
                        }
                        <ShowIf condition={this.props.addNew == true}>
                          <td style={{minWidth: 150}}>
                            <span>&nbsp;</span>
                          </td>
                        </ShowIf>
                        <ShowIf condition={this.state.dataList.length > 1}>
                          <td style={{width: 110, minWidth: 110, maxWidth: 110}} className='txt-left'>{this.state.dataSum[item.field] ? this.state.dataSum[item.field] : (item.ms ? 0 : '')}</td>
                        </ShowIf>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
            <table className='table-fixed' id="tableFixed">
                <thead className='table-header'>
                  <tr>
                    <th style={{width: 40, minWidth: 40, maxWidth: 40}} className='middle-content'>MS</th>
                    <th style={{width: 600, minWidth: 600, maxWidth: 600}} className='middle-content txt-left'>Nội dung</th>
                    <th style={{width: 110, minWidth: 110, maxWidth: 110}} className='middle-content txt-left'>Đơn vị tính</th>
                    {
                      this.state.dataList.map((item, index) => {
                        if(typeof item.donVi != 'undefined' && item.donVi.id) {
                          return(
                            <th style={{minWidth: 150, maxWidth: 150, width: 150, opacity: 0, visibility: 'hidden'}} key={index} className='middle-content txt-left'>{item && item.donVi && item.donVi.ten ? item.donVi.ten : ''}</th>
                          )
                        } else {
                          return(
                            <td style={{minWidth: 150, maxWidth: 150, width: 150, opacity: 0, visibility: 'hidden'}} key={index} className='txt-left'><Input className='col-100 no-gutter mb0-18' onChange={this.onChangeHeader.bind(this, index)} triggeOnBlur={true} value={item && item.donVi && item.donVi.ten ? item.donVi.ten : ''}/></td>
                          )
                        }
                      })
                    }
                    <ShowIf condition={this.props.addNew == true}>
                      <th style={{minWidth: 150, opacity: 0, visibility: 'hidden'}} className='middle-content txt-left'>
                        <span className='tr-sum-name txt-blue pointer' onClick={this.addNewItem.bind(this)}><i className='tt tt-addfile tt-custom'/>Thêm mới đơn vị</span>
                      </th>
                    </ShowIf>
                    <ShowIf condition={this.state.dataList.length > 1}>
                      <th style={{width: 110, minWidth: 110, maxWidth: 110, opacity: 0, visibility: 'hidden'}} className='middle-content txt-left'>Tổng cộng</th>
                    </ShowIf>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.state.header.map((item, index) => {
                      return(
                        <tr key={index}>
                          <td style={{width: 40, minWidth: 40, maxWidth: 40}}>{item.ms ? item.ms : ''}</td>
                          <td style={{width: 600, minWidth: 600, maxWidth: 600}} className={`txt-left ${item.className ? item.className : ''}`}>{item.content ? item.content : ''}</td>
                          <td style={{width: 110, minWidth: 110, maxWidth: 110}} className='txt-left'>{item.unit ? item.unit : ''}</td>
                          {
                            this.state.dataList.map((data, i) => {
                              if(item.ms == null) {
                                return(
                                  <td style={{minWidth: 150, maxWidth: 150, width: 150, opacity: 0, visibility: 'hidden'}} key={i} className='txt-left'>{data && data[item.field] ? data[item.field] : (item.ms ? 0 : '')}</td>
                                )
                              } else {
                                return(
                                  <td style={{minWidth: 150, maxWidth: 150, width: 150, opacity: 0, visibility: 'hidden'}} key={i} className='txt-left'><Input className='col-100 no-gutter mb0-18' onChange={this.onChange.bind(this, item.field, i)}  value={data && data[item.field] ? data[item.field] : 0}/></td>
                                )
                              }
                            })
                          }
                        </tr>
                      )
                    })
                  }
                </tbody>
            </table>
          </div>
          <table className='table-scroll'>
            <thead className='table-header' style={{opacity: 0, visibility: 'hidden'}}>
              <tr>
                <th style={{width: 40, minWidth: 40, maxWidth: 40, opacity: 0, visibility: 'hidden'}} className='middle-content'>MS</th>
                <th style={{width: 600, minWidth: 600, maxWidth: 600, opacity: 0, visibility: 'hidden'}} className='middle-content txt-left'>Nội dung</th>
                <th style={{width: 110, minWidth: 110, maxWidth: 110, opacity: 0, visibility: 'hidden'}} className='middle-content txt-left'>Đơn vị tính</th>
                {
                  this.state.dataList.map((item, index) => {
                    if(typeof item.donVi != 'undefined' && item.donVi.id) {
                      return(
                        <th style={{minWidth: 150, maxWidth: 150, width: 150}} key={index} className='middle-content txt-left'>{item && item.donVi && item.donVi.ten ? item.donVi.ten : ''}</th>
                      )
                    } else {
                      return(
                        <td style={{minWidth: 150, maxWidth: 150, width: 150}} key={index} className='txt-left'><Input className='col-100 no-gutter mb0-18' onChange={this.onChangeHeader.bind(this, index)} triggeOnBlur={true} value={item && item.donVi && item.donVi.ten ? item.donVi.ten : ''}/></td>
                      )
                    }
                  })
                }
                <ShowIf condition={this.props.addNew == true}>
                  <th style={{minWidth: 150}} className='middle-content txt-left'>
                    <span className='tr-sum-name txt-blue pointer' onClick={this.addNewItem.bind(this)}><i className='tt tt-addfile tt-custom'/>Thêm mới đơn vị</span>
                  </th>
                </ShowIf>
                <ShowIf condition={this.state.dataList.length > 1}>
                  <th style={{width: 110, minWidth: 110, maxWidth: 110}} className='middle-content txt-left'>Tổng cộng</th>
                </ShowIf>
              </tr>
            </thead>
            <tbody>
              {
                this.state.header.map((item, index) => {
                  return(
                    <tr key={index}>
                      <td style={{width: 40, minWidth: 40, maxWidth: 40, opacity: 0, visibility: 'hidden'}}>{item.ms ? item.ms : ''}</td>
                      <td style={{width: 600, minWidth: 600, maxWidth: 600, opacity: 0, visibility: 'hidden'}} className={`txt-left ${item.className ? item.className : ''}`}>{item.content ? item.content : ''}</td>
                      <td style={{width: 110, minWidth: 110, maxWidth: 110, opacity: 0, visibility: 'hidden'}} className='txt-left'>{item.unit ? item.unit : ''}</td>
                      {
                        this.state.dataList.map((data, i) => {
                          if(item.ms == null) {
                            return(
                              <td style={{minWidth: 150, maxWidth: 150, width: 150}} key={i} className='txt-left'>{data && data[item.field] ? data[item.field] : (item.ms ? 0 : '')}</td>
                            )
                          } else {
                            return(
                              <td style={{minWidth: 150, maxWidth: 150, width: 150}} key={i} className='txt-left'><Input className='col-100 no-gutter mb0-18' onChange={this.onChange.bind(this, item.field, i)} type='sdt' triggeOnBlur={true} value={data && data[item.field] ? data[item.field] : 0}/></td>
                            )
                          }
                        })
                      }
                      <ShowIf condition={this.props.addNew == true}>
                        <td style={{minWidth: 150}}>
                          <span>&nbsp;</span>
                        </td>
                      </ShowIf>
                      <ShowIf condition={this.state.dataList.length > 1}>
                        <td style={{width: 110, minWidth: 110, maxWidth: 110}} className='txt-left'>{this.state.dataSum[item.field] ? this.state.dataSum[item.field] : (item.ms ? 0 : '')}</td>
                      </ShowIf>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
        <ShowIf condition={!this.props.hideExport}>
          <div className="pagination-wrap">
            <Button className='btn-green tt-export' text={ this.props.exporttext } onClick={ this.handleExport.bind(this) } />
          </div>
        </ShowIf>
      </div>
    )
  }
}

export default TableKetQuaPhongChongThamNhung;



// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-dinh-ky/TableKetQuaPhongChongThamNhung.jsx